(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-hub-scanpan"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(e){
  var t=e.target.closest('.pg-tab'); if(!t) return;
  var w=t.closest('.pg-wrap'); if(!w) return;
  w.querySelectorAll('.pg-tab').forEach(function(x){x.classList.remove('active')});
  t.classList.add('active');
  var f=t.getAttribute('data-f');
  w.querySelectorAll('.pg-sec').forEach(function(s){
    var k=s.getAttribute('data-sec');
    s.style.display=(f==='all'||k===f||k==='about')?'':'none';
  });
});

  } catch(e) { console.error(e); }
})();
})();
